import React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";
import { Avatar as AvatarUI } from "@/ui/avatar";

export const Avatar = React.forwardRef<React.ElementRef<typeof AvatarUI>, {
    children: React.ReactNode | string,
    className?: string,
    size?: number,
}>(({
    children,
    className,
    size,
    ...props
}, ref) => (
    <AvatarUI
        ref={ref}
        className={generateValidClassNameHandler(
            size ? `size-${size}` : "",
            className,
        )}
        {...props}
    >
        {children}
    </AvatarUI>
));
